import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import * as chat from './chat/index';
import * as drawers from './drawers/index';
import * as forms from './forms/index';
import * as helpMode from './helpMode/index';
import * as modals from './modals/index';
import * as smartComponents from './smartComponents/index';
import userGroupManagementReducer from './userGroupManagement/data/reducer';
import userGroupManagementSaga from './userGroupManagement/data/sagas';
import * as viewer from './viewer/index';

export const reducer = combineReducers({
  chat: chat.reducer,
  drawers: drawers.reducer,
  forms: forms.reducer,
  helpMode: helpMode.reducer,
  modals: modals.reducer,
  smartComponents: smartComponents.reducer,
  userGroupManagement: userGroupManagementReducer,
  viewer: viewer.reducer,
});

export const saga = function* () {
  yield all([
    chat.saga(),
    drawers.saga(),
    forms.saga(),
    modals.saga(),
    smartComponents.saga(),
    userGroupManagementSaga(),
    viewer.saga(),
  ]);
};
